// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"318":"57b93404","489":"6eb3d8ba","544":"51a2d6ac","978":"59641d1d","992":"aad87ea1"}[chunkId] + ".css";
};